// Create a simple placeholder image component for properties and blog posts
export const createPlaceholderImage = (width: number, height: number, text: string = 'Property Image') => {
  return `data:image/svg+xml;base64,${btoa(`
    <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
      <rect width="100%" height="100%" fill="#f3f4f6"/>
      <text x="50%" y="50%" font-family="Arial, sans-serif" font-size="14" fill="#6b7280" text-anchor="middle" dy=".3em">
        ${text}
      </text>
    </svg>
  `)}`;
};

// Property placeholder images using actual images from public folder
export const propertyPlaceholders = {
  villa: '/kerala-backwaters-banner.jpg',
  residential: '/kerala-test.jpg', 
  house: '/hero-background.jpg',
  land: '/pop3i-original-banner.jpg',
  commercial: '/pop3i-correct-banner.png'
};

// Blog placeholder images using actual images from public folder
export const blogPlaceholders = {
  investment: '/kerala-backwaters-banner.jpg',
  market: '/hero-background.jpg',
  legal: '/kerala-test.jpg',
  infrastructure: '/pop3i-original-banner.jpg',
  sustainability: '/kerala-backwaters-banner.jpg'
};
